<div class="sh-page-template__main__content">
    <div class="sh-template-stack">
        <sh-page-header class="sh-template-stack__item" [title]="'reports.title' | translate"></sh-page-header>

        <sh-display-settings-bar
            *ngIf="reports$ | async as reports"
            [showSortSelect]="false"
            [showViewToggle]="false"
            [sortPrefixMessage]="'sort.prefix' | translate"
            [sortLoadingMsg]="'general.filter.loading' | translate"
            [xxResultsLabelKey]="'general.xx-results.report'"
            [noResultsLabelKey]="'general.no-results.report'"
            [totalResults]="(error$ | async) ? 0 : reports.results.length"
        >
        </sh-display-settings-bar>
        <div class="sh-template-stack__item">
            <div class="sh-card-table-wrapper">
                <table class="sh-card-table" id="reports-overview">
                    <thead>
                        <tr>
                            <th scope="col" width="600">{{ "reports.table.columns.name" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="loading$ | async">
                            <td [colSpan]="COLUMN_COUNT">{{ "ui.loading" | translate }}</td>
                        </tr>

                        <tr *ngIf="!(loading$ | async) && !(error$ | async) && (reports$ | async)?.results.length === 0">
                            <td [colSpan]="COLUMN_COUNT">{{ "reports.messages.empty-list" | translate }}</td>
                        </tr>

                        <tr class="sh-card-table__row--error" *ngIf="error$ | async">
                            <td [colSpan]="COLUMN_COUNT">{{ "reports.messages.failed-to-fetch" | translate }}</td>
                        </tr>

                        <ng-container *ngIf="!(loading$ | async) && !(error$ | async) && (reports$ | async)?.results.length > 0">
                            <tr *ngFor="let report of (reports$ | async)?.results">
                                <th scope="row" [id]="report.Id">
                                    <a [routerLink]="report.Id" class="sh-list-row-title">
                                        <h3 class="sh-list-row-title__title -sh-wrap">{{ report.Label }}</h3>
                                    </a>
                                </th>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
        <sh-pagination
            [paginationInfo]="paginationInfo$ | async"
            [previousPageMsg]="'components.pagination.previous' | translate"
            [nextPageMsg]="'components.pagination.next' | translate"
            (paginationInfoChanged)="onPaginationInfoChanged($event)"
        >
        </sh-pagination>
    </div>
</div>
